import SkeletonLoader from "./skeleton-loader";

export default function BankActionButtonsSkeleton() {
    return (
        <div className="quick-actions skeleton">
          <SkeletonLoader className="border--rounded-lg bg--loader-bg-dark-secondary" width="100%" height={56} />
          <SkeletonLoader className="border--rounded-lg bg--loader-bg-dark-secondary" width="100%" height={56} />
          <SkeletonLoader className="border--rounded-lg bg--loader-bg-dark-secondary" width="100%" height={56} />
        </div>
    );
}
